import { render, staticRenderFns } from "./ContactUs_box1_inner.vue?vue&type=template&id=7c56c44c"
import script from "./ContactUs_box1_inner.vue?vue&type=script&lang=js"
export * from "./ContactUs_box1_inner.vue?vue&type=script&lang=js"
import style0 from "./ContactUs_box1_inner.vue?vue&type=style&index=0&id=7c56c44c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports